import React, { useState } from 'react';
import SmoothCollapse from 'react-smooth-collapse';

import Criterion from './criterion';

import { IPrinciple } from '../../../../types/audit-config';

import './principle.scss';

const Principle = ({ principleObj }: { principleObj: IPrinciple }) => {
  // LOCAL STATE
  const [activeSection, setActiveSection] = useState(false);

  return (
    <div className='principle-container'>
      <div
        key={principleObj.principle}
        className='principle-container__title'
        onClick={() => setActiveSection(!activeSection)}
      >
        <div className='subtitle'>Principle {principleObj.principle}</div>
        <div className='title'>{principleObj.title}</div>
        <span className={`esri-icon-down ${activeSection ? 'open' : ''}`} />
      </div>
      <SmoothCollapse expanded={activeSection} className='principle-container__criterions' allowOverflowWhenOpen>
        {principleObj.criterion.map((criterionObj, key) => (
          <Criterion key={key} criterion={criterionObj} />
        ))}
      </SmoothCollapse>
    </div>
  );
};

export default Principle;
